import { useState, useEffect, useCallback } from 'react';

export function useCompare() {
  const [compareIds, setCompareIds] = useState(() => {
    try {
      const stored = localStorage.getItem('compareCards');
      return stored ? JSON.parse(stored) : [];
    } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('compareCards', JSON.stringify(compareIds));
  }, [compareIds]);

  const addToCompare = useCallback((id) => {
    setCompareIds(prev => prev.includes(id) ? prev : [...prev, id].slice(0, 4));
  }, []);

  const removeFromCompare = useCallback((id) => {
    setCompareIds(prev => prev.filter(cid => cid !== id));
  }, []);

  const toggleCompare = useCallback((id) => {
    setCompareIds(prev => prev.includes(id) ? prev.filter(cid => cid !== id) : [...prev, id].slice(0, 4));
  }, []);

  const clearCompare = useCallback(() => setCompareIds([]), []);
  const isInCompare = useCallback((id) => compareIds.includes(id), [compareIds]);

  return { compareIds, addToCompare, removeFromCompare, toggleCompare, clearCompare, isInCompare };
}

export function useFavorites() {
  const [favoriteIds, setFavoriteIds] = useState(() => {
    try {
      const stored = localStorage.getItem('favoriteCards');
      return stored ? JSON.parse(stored) : [];
    } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('favoriteCards', JSON.stringify(favoriteIds));
  }, [favoriteIds]);

  const toggleFavorite = useCallback((id) => {
    setFavoriteIds(prev => prev.includes(id) ? prev.filter(fid => fid !== id) : [...prev, id]);
  }, []);

  const isFavorite = useCallback((id) => favoriteIds.includes(id), [favoriteIds]);
  const clearFavorites = useCallback(() => setFavoriteIds([]), []);

  return { favoriteIds, toggleFavorite, isFavorite, clearFavorites };
}
